import { render, staticRenderFns } from "./edit-vcard-dialog.vue?vue&type=template&id=b26bc6ca&scoped=true&"
import script from "./edit-vcard-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-vcard-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26bc6ca",
  null
  
)

export default component.exports